import apiPaths from '../api-paths';

export default {
  get() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef-configuration`);
  },
  save(data) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/ksef-configuration`, data);
  },
  testConnection(data) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/ksef-configuration/test-connection`, data);
  },
  getAuditLog(query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef-configuration/audit-log${ query }`);
  },
  getStatus() {
    return axios.get(`${ apiPaths.BOOKKEEPING }/ksef-configuration/status`);
  },
};
